module.exports = __webpack_public_path__ + "img/antdv.191648cd.png";